import {apiUrl} from '../../context/context';
import {acerillAuthenticatedAxios} from './acerill-axios-instances';

const baseUrl = `${apiUrl}/notification/v1`;

const saveTemplate = template => {
  return acerillAuthenticatedAxios
    .put(
      `${baseUrl}/custom-forms/templates/${encodeURIComponent(template.id)}`,
      template
    )
    .then(response => response.data || {});
};

const findTemplateById = id => {
  return acerillAuthenticatedAxios
    .get(`${baseUrl}/custom-forms/templates/${encodeURIComponent(id)}`)
    .then(response => response.data);
};

const notificationV1Client = {
  saveTemplate,
  findTemplateById,
};
export default notificationV1Client;
